import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "login-container p-d-flex p-jc-center p-ai-center" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = {
  key: 0,
  class: "error-message p-mb-3"
}
const _hoisted_4 = { class: "p-input-filled p-mb-3" }
const _hoisted_5 = { class: "p-float-label p-input-icon-right" }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "p-input-filled p-mb-4" }
const _hoisted_8 = { class: "p-float-label p-input-icon-right" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "p-d-flex p-jc-between p-mb-3" }
const _hoisted_11 = { class: "p-field-checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_message = _resolveComponent("p-message")!
  const _component_p_text = _resolveComponent("p-text")!
  const _component_p_checkbox = _resolveComponent("p-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_p_button = _resolveComponent("p-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "logo-container" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "SimForce Logo",
          class: "logo"
        }),
        _createElementVNode("h1", null, "SimForce")
      ], -1)),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_p_message, {
              severity: "error",
              closable: false
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.error), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "pi pi-user" }, null, -1)),
          _createVNode(_component_p_text, {
            id: "username",
            modelValue: _ctx.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            type: "text",
            class: _normalizeClass(["p-inputtext-lg", {'p-invalid': _ctx.submitted && !_ctx.username}]),
            style: {"width":"100%"}
          }, null, 8, ["modelValue", "class"]),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "username" }, "Username", -1))
        ]),
        (_ctx.submitted && !_ctx.username)
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, "Username is required"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "pi pi-lock" }, null, -1)),
          _createVNode(_component_p_text, {
            id: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            type: "password",
            class: _normalizeClass(["p-inputtext-lg", {'p-invalid': _ctx.submitted && !_ctx.password}]),
            style: {"width":"100%"}
          }, null, 8, ["modelValue", "class"]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "password" }, "Password", -1))
        ]),
        (_ctx.submitted && !_ctx.password)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, "Password is required"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_p_checkbox, {
            modelValue: _ctx.rememberMe,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event)),
            binary: "",
            id: "rememberMe"
          }, null, 8, ["modelValue"]),
          _cache[7] || (_cache[7] = _createElementVNode("label", { for: "rememberMe" }, "Remember Me", -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/forgot-password",
            class: "forgot-password"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Forgot Password?", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_p_button, {
        label: "Login",
        icon: "pi pi-sign-in",
        class: "p-button-lg p-mb-3",
        style: {"width":"100%"},
        onClick: _ctx.handleLogin,
        loading: _ctx.loading
      }, null, 8, ["onClick", "loading"]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "p-mt-4 help-text" }, [
        _createElementVNode("p", null, "Having trouble logging in? Contact your administrator.")
      ], -1))
    ])
  ]))
}